import React from "react";

const StepContainer = ({
  currentStep,
  totalSteps,
  title,
  subtitle,
  children,
  onSubmit,
  buttonText = "Continuar",
  buttonClass = "btn-sirio",
}) => {
  return (
    <div className="login-content" style={{ width: "100%", maxWidth: "100%" }}>
      <div className="text-center mb-5">
        <p
          className="fw-bold mb-2"
          style={{ color: "#4a6502", letterSpacing: "2px", fontSize: "0.8rem" }}
        >
          PASO {String(currentStep).padStart(2, "0")} DE{" "}
          {String(totalSteps).padStart(2, "0")}
        </p>
        <h1 className="fw-bolder" style={{ color: "#162b4d" }}>
          {title}
        </h1>
        <p className="text-muted fs-5">{subtitle}</p>
      </div>

      <form id="frmRegister" className="margin-bottom-0" onSubmit={onSubmit}>
        {children}

        <div className="login-buttons text-center mt-5 mb-3 d-flex flex-column align-items-center">
          {currentStep === totalSteps ? (
            <div className="d-grid gap-2">
              <a
                href="/user/login-v3"
                className="btn btn-lg fw-bold text-white"
                style={{
                  backgroundColor: "#4a6502",
                  borderRadius: "8px",
                  padding: "14px 24px",
                  fontSize: "1rem",
                  textDecoration: "none",
                }}
              >
                Ir a la Consola de Sirio{" "}
                <i className="fa fa-arrow-right ms-2"></i>
              </a>
            </div>
          ) : (
            <button
              type="submit"
              className={`btn btn-lg ${buttonClass} d-flex align-items-center justify-content-center px-5 py-3`}
              style={{ borderRadius: "10px" }}
            >
              {buttonText}{" "}
              {buttonText === "Continuar" && (
                <i
                  className="fa fa-chevron-right ms-2"
                  style={{ fontSize: "0.9rem" }}
                ></i>
              )}
              {buttonText === "Finalizar" && (
                <i
                  className="fa fa-check ms-2"
                  style={{ fontSize: "0.9rem" }}
                ></i>
              )}
            </button>
          )}

          {currentStep === 1 && (
            <div className="mt-3">
              <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                AL CONTINUAR ACEPTAS LOS TÉRMINOS DE LICENCIA DE USO DE SOFTWARE
              </small>
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default StepContainer;
